// extracted by mini-css-extract-plugin
export default {"root":"efFv5I","description":"aPAPZB"};